// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4f-0";
export var eligibilityCardNotEligible = "_4f-1";